import { alpha } from "@mui/material";

// iOS input zoom prevention through theme component overrides
export const getIOSInputZoomPreventionThemeComponents = () => ({
  // Override TextField/OutlinedInput
  MuiOutlinedInput: {
    styleOverrides: {
      input: {
        "@media screen and (max-width: 767px)": {
          fontSize: "16px !important",
        },
      },
    },
  },
  // Override basic Input
  MuiInput: {
    styleOverrides: {
      input: {
        "@media screen and (max-width: 767px)": {
          fontSize: "16px !important",
        },
      },
    },
  },
  // Override FilledInput
  MuiFilledInput: {
    styleOverrides: {
      input: {
        "@media screen and (max-width: 767px)": {
          fontSize: "16px !important",
        },
      },
    },
  },
  // Override Select
  MuiSelect: {
    styleOverrides: {
      select: {
        "@media screen and (max-width: 767px)": {
          fontSize: "16px !important",
        },
      },
    },
  },
  // Override NativeSelect
  MuiNativeSelect: {
    styleOverrides: {
      select: {
        "@media screen and (max-width: 767px)": {
          fontSize: "16px !important",
        },
      },
    },
  },
  // Override Autocomplete input
  MuiAutocomplete: {
    styleOverrides: {
      input: {
        "@media screen and (max-width: 767px)": {
          fontSize: "16px !important",
        },
      },
    },
  },
});

export const componentStyles = (fontSize = "100%") => ({
  MuiCssBaseline: {
    styleOverrides: (themeParam: any) => `
    html {
      font-size: ${fontSize}; /* Apply the dynamic font-size */
    }
    ::-webkit-scrollbar {
      width: 4px;
      transition: width 0.3s; 
    }
    ::-webkit-scrollbar-track {
      background-color: ${themeParam.palette.background.paper}; 
    }
    ::-webkit-scrollbar-thumb {
      background-color: ${alpha(
        themeParam.palette.gray?.light || "#DFE3E7",
        0.75
      )}; 
      border-radius: 5px;
    }
    ::-webkit-scrollbar-thumb:hover {
      background-color: ${alpha(
        themeParam.palette.gray?.light || "#DFE3E7",
        0.75
      )};
    }
    /* For Firefox */
    * {
      scrollbar-color: ${alpha(
        themeParam.palette.gray?.light || "#DFE3E7",
        0.75
      )} ${themeParam.palette.background.paper};
      scrollbar-width: thin;
    }
    `,
  },
  // Add iOS input zoom prevention component overrides
  ...getIOSInputZoomPreventionThemeComponents(),
});

export const getCustomStyles = (BotConfigs: any, fontSize = "100%") => {
  return {
    palette: {
      primary: {
        dark: BotConfigs?.color?.custom?.primary?.dark || "#4A4866",
        main: BotConfigs?.color?.custom?.primary?.main || "#0031E0",
        light: BotConfigs?.color?.custom?.primary?.light || "#F3F7FF",
      },
      secondary: {
        dark: BotConfigs?.color?.custom?.secondary?.dark || "#530b9a",
        main: BotConfigs?.color?.custom?.secondary?.main || "#8F1EFF",
        light: BotConfigs?.color?.custom?.secondary?.light || "#CAD5FF",
      },
      gray: {
        dark: "#6E7879",
        main: "#9FA6B2",
        light: "#DFE3E7",
        darker: "#4B5563",
        darkest: "#252F3F",
        lighter: "#F1F4F7",
        lightest: "#FCFDFE",
      },
    },
    typography: {
      fontFamily:
        BotConfigs?.font ||
        '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    },
    shape: {
      borderRadius: BotConfigs?.style?.corner_radius || 8,
    },
    components: componentStyles(fontSize),
  };
};

export const baseBotTheme = (fontSize = "100%") => ({
  palette: {
    primary: {
      main: "#0031E0",
      dark: "#4A4866",
      light: "#F3F7FF",
      grey: "#898989",
    },
    secondary: {
      main: "#8F1EFF",
      light: "#CAD5FF",
      contrastText: "#fff",
    },
    gray: {
      dark: "#6E7879",
      main: "#9FA6B2",
      light: "#DFE3E7",
      darker: "#4B5563",
      darkest: "#252F3F",
      lighter: "#F1F4F7",
      lightest: "#FCFDFE",
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: componentStyles(fontSize),
});
